import { ModelTranslator } from '@/types/ApiResponseTypes'
import { InternetUsageRequestBody } from '@/types/internet/InternetResponseType'
import { isInternetUsageRequest } from '@/types/internet/InternetType'
import { dateTostring } from '@/utils/common'

class InternetUsageRequestBodyTranslator implements ModelTranslator<InternetUsageRequestBody> {
  convertToModel(model: any): InternetUsageRequestBody {
    if (isInternetUsageRequest(model)) {
      return {
        dateFrom: model.dateFrom == undefined ? '' : dateTostring(model.dateFrom),
        dateTo: model.dateTo == undefined ? '' : dateTostring(model.dateTo),
        period: model.period == 'day' ? 'day' : 'month',
      }
    }
    return {} as InternetUsageRequestBody
  }
}

export default new InternetUsageRequestBodyTranslator()
